import { h } from 'preact'
import InputGroup from '../ui-components/InputGroup'
import ButtonControl from '../button-control'
import AbstractProvider, { ProvidedItems } from './AbstractProvider'
import { SetupProps } from './types'

const OpenIDSetup = (props: SetupProps) =>
  <AbstractProvider {...props}>
    {({ configuration, onSubmit, getError, getSubmitButtonProps, onInputChange } : ProvidedItems) =>
      <div className='form-enumeration'>
        <div className='form-enumeration__number'>1</div>
        <div className='form-enumeration__step-title'>Go to your OpenID provider application and provide the
              following information.
        </div>
        <div className='form-enumeration__step-line' />
        <div className='form-enumeration__step-empty' />
        <div className='form-enumeration__number'>2</div>
        <div className='form-enumeration__step-title'>Provide OpenID credentials</div>
        <div />
        <div className='form-enumeration__step-content'>
          <p>Once you fill in these details and press 'Save changes', users on the community will be able to login
                using SSO, given all the information is provided is correct.</p>
          <form onSubmit={onSubmit}>
            <div>
              {props.provider.fields.map(field => {
                return <InputGroup
                  title={field.label}
                  type='text'
                  value={configuration[field.name]}
                  onChangeCallback={(e: ChangeEvent) => onInputChange(field.name, e.target.value)}
                  error={getError(field.name) || undefined}
                />
              })}
            </div>
            <div>
              <ButtonControl {...getSubmitButtonProps()} />
              <ButtonControl
                title='Cancel'
                variant='secondary'
                onClick={() => window.location.assign('/integration/sso')}
              />
            </div>
          </form>
        </div>
      </div>
    }
  </AbstractProvider>

export default OpenIDSetup
